angular.module('SpidApp')

.constant('OrderItemAdapterConfig', {
  name : 'OrderItem',
  fields : [
    {
    	local   : 'id',
    	distant : 'id'
    }, {
    	local   : 'orders_id',
    	distant : 'order_id'
    }, {
  		local   : 'obj_id',
  		distant : 'obj_id'
    }, {
  		local   : 'obj_table_ref',
  		distant : 'obj_table_ref'
  	}, {
  		local   : 'unit',
  		distant : 'quantity_request'
  	}, {
  		local   : 'quantity_get',
  		distant : 'quantity_get'
  	}, {
  		local   : 'quantity_send',
  		distant : 'quantity_sent'
  	}, {
  		local   : 'label',
  		distant : 'label'
  	}, {
	    local   : 'updated_at',
	    distant : 'updated_at'
  	}, {
      local   : 'agency_id',
      distant : 'agency_id'
    }, {
      local   : 'lot',
      distant : 'lot'
    }
  ]
})